import React, { useState, useEffect } from "react";
import "./HeroSlider.css";
import LandingPage from './LandingPage';
import Features from './Features';
import LandingPage1 from './LandingPage1';
import ServicesPage from './ServicesPage';
import ContactSection from './ContactSection';

export default function HeroSlider() {
  const images = [
    "/img1.jpeg",
    "/img2.jpeg",
    "/img3.jpeg",
  ];


  const images1 = [
  "/1.png",
  "/2.png",
  "/3.png",
  "/4.png",
];

  const [index, setIndex] = useState(0);

  // מעבר אוטומטי כל 3 שניות
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

return (
    <>

  <div className="slider-container">

    {/* סליידר מסך מלא */}
    <img src={images[index]} alt="slider" className="main-slider" />

    {/* צד ימין קבוע */}
    <div className="right-overlay">

      {/* כותרת */}
<div className="hero-text">

  <h3 className="overlay-title">איטומים בגבהים</h3>
  <h2>      קבלן ויועץ שיקום מבנים עבודות איטום בסנפלינג !    </h2>
  <h2>    חברה לשיקום מבנים , עבודות איטום וסנפלינג !</h2>

  <h2>מתמחים בייעוץ וביצוע שיקום מבנים עבודות
איטום גגות וסנפלינג
 </h2>


</div>

  <div className="images-row">
    {images1.map((img, i) => (
      <div className="img-box" key={i}>
        <img src={img} alt={`img-${i}`} />
    
      </div>
          ))}
        </div>
      </div>
    </div>

    {/* 🔥 חשוב: הדפים מחוץ לסליידר */}
       <ServicesPage />
          <LandingPage/>
    <Features />
     
    <LandingPage1 />
   <ContactSection />
  </>
);
}